import React, { useState, useEffect } from 'react';
import { useLocation } from 'react-router-dom';
import { Link, useNavigate } from 'react-router-dom';
import { BsPeople, BsPerson, BsCheck2Circle, BsDisplay, BsQuestion, BsFolder, BsGear } from 'react-icons/bs';
import Sidebar from '../dashboard/sidebar';
import Navbar from '../dashboard/navbar';
import useAuth from '../dashboard/useAuth';
import axios from 'axios';
import { FaCogs, FaUserShield, FaRegClipboard, FaBoxes, FaChalkboardTeacher, FaQuestionCircle, FaTags, FaProcess, FaTh, FaRegQuestionCircle, FaHandshake, FaMoneyBill, FaClipboardList, FaNewspaper, FaCalendarCheck, FaCalendarAlt, FaCalendarWeek, FaStar, FaUserClock, FaCertificate } from 'react-icons/fa';

const Admin = ({ titre }) => {
  useAuth();
  const navigate = useNavigate();
  const location = useLocation();
  const user_id = localStorage.getItem('user_id');
  const accesGroupe = localStorage.getItem('accesGroupe');
  const groupe = localStorage.getItem('groupe');

  useEffect(() => {
    if (user_id) {
      document.title = "eTrainApp | Administration";
    }
  }, [user_id]);

  const userHasAccess = (accessKey) => {
    return accesGroupe && accesGroupe.includes(accessKey);
  };

  const handleClick = (link) => {
    navigate(link);
  };


  const menuItems = [
    { icon: <FaUserShield />, text: 'Éligibilité', link: '/Eligibilites-soumises', accessKey: 'AdminEligibilite' },
    { icon: <BsPeople />, text: 'Groupes', link: '/Liste-groupe', accessKey: 'Groupes' },
    { icon: <BsPerson />, text: 'Utilisateurs', link: '/Liste-utilisateur', accessKey: 'Utilisateurs' },
    { icon: <FaUserClock />, text: 'Inscriptions', link: '/Liste-inscription', accessKey: 'Inscription' },
    { icon: <FaCalendarAlt className="text-primary" />, text: 'Booking', link: '/RDV-admin', accessKey: 'AdminRdv' },
    // { icon: <FaCalendarWeek className="text-primary" />, text: 'Mes bookings', link: '/Booking-coach', accessKey: 'CoachRdv' },
    // { icon: <FaBoxes />, text: 'Produits', link: '/Liste-produit', accessKey: 'Produits' },
    { icon: <FaChalkboardTeacher />, text: 'Formation', link: '/Liste-formation', accessKey: 'Formation' },
    { icon: <FaCertificate />, text: 'Spécialités', link: '/Liste-specialite', accessKey: 'Formation' },
    { icon: <FaRegQuestionCircle />, text: 'QCM', link: '/Liste-qcm', accessKey: 'QCM' },
    { icon: <FaStar />, text: 'Avis client', link: '/Gestion-avis-client', accessKey: 'QCM' },
    { icon: <FaTags />, text: 'TAG', link: '/Liste-tag', accessKey: 'QCM' },
    { icon: <BsDisplay />, text: 'ECO', link: '/Liste-eco', accessKey: 'QCM' },
    { icon: <FaTh />, text: 'Domaine', link: '/Liste-domaine', accessKey: 'QCM' },
    { icon: <i className="fa fa-bookmark-o" />, text: 'Processus', link: '/Liste-groupe-processus', accessKey: 'QCM' },
    { icon: <FaNewspaper />, text: 'Examen Blanc', link: '/Gestion-des-examens', accessKey: 'AdminExamenBlanc' },
    { icon: <i className="fa fa-rss" />, text: 'Liste de diffusion', link: '/Liste-diffusion', accessKey: 'ListeDeDiffusion' },
    { icon: <i className="fa fa-bell-o" />, text: 'Notifications', link: '/Liste-notification', accessKey: 'Notification' },
    { icon: <i className="fa fa-envelope" />, text: 'Newsletter', link: '/NewsLetters', accessKey: 'Notification' },
    { icon: <i className="fa fa-line-chart" />, text: 'Parcours', link: '/Liste-parcours', accessKey: 'Parcours' },
    { icon: <FaChalkboardTeacher />, text: 'Etude de cas', link: '/Liste-etude', accessKey: 'AdminEtudeDeCas' },
    { icon: <FaRegClipboard />, text: 'Mise en situation', link: '/Liste-situation', accessKey: 'AdminEtudeDeCas' },
    { icon: <i className="fa fa-exclamation" />, text: 'Dictionnaire', link: '/Liste-dictionnaire', accessKey: 'AdminQuiz' },
    { icon: <FaMoneyBill className="text-primary" />, text: 'Souscriptions', link: '/Liste-souscription-admin', accessKey: 'Souscription' },
    { icon: <FaHandshake className="text-primary" />, text: 'Partenaire', link: '/Liste-partenaire', accessKey: 'Partenaire' },
    { icon: <FaClipboardList className="text-primary" />, text: 'Journalisation', link: '/Journalisation', accessKey: 'Journalisation' },
  ];


  return (
    <div id="wrapper">
      <Sidebar user_id={user_id} titre={titre} />
      <div id="page-wrapper" className="gray-bg">
        <Navbar />
        <div>
          <div className="row wrapper border-bottom white-bg page-heading">
            <div className="col-lg-12">
              <h2 className='d-flex align-items-center'><FaCogs size={25} className='mr-2' /> Administration</h2>
              <small id='hbreadcrumb' className='d-flex justify-content-end'>
                <ol className="breadcrumb">
                  {/* <li className="breadcrumb-item custom-breadcrumb-item">
                    <Link to={`/Menu`}> Accueil</Link>
                  </li> */}
                  <li className="breadcrumb-item">
                    Administration
                  </li>
                </ol>
              </small>
            </div>
          </div>



          <div className="wrapper wrapper-content animated fadeInRight text-center p-5">
            <div className="row mx-auto justify-content-center">
              {menuItems.map((item, index) => (
                userHasAccess(item.accessKey) && (
                  <div key={index} className="col-md-2 mb-4">
                    <div
                      className="card rounded shadow-sm"
                      onClick={() => handleClick(item.link)}
                      style={{
                        cursor: 'pointer',
                        transition: 'transform 0.2s'
                      }}
                      onMouseEnter={(e) => e.currentTarget.style.transform = 'scale(1.05)'}
                      onMouseLeave={(e) => e.currentTarget.style.transform = 'scale(1)'}
                    >
                      <div className="card-body">
                        <div className="mb-3 icon-small">{item.icon}</div>
                        <h5><Link className='text-dark' to={item.link}>{item.text}</Link></h5>
                      </div>
                    </div>
                  </div>
                )
              ))}
            </div>
          </div>
        </div>
      </div>
    </div>
  );
};

export default Admin;